import { globalOptions } from 'SRC/core/constants'
import { NotificationsListApi } from '../../api'
import { setNotifications } from '../setNotifications'
import { setLoading } from '../setLoading'

export const unreadNotification = ({ userId, token, notification }) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true))
      const api = new NotificationsListApi()

      const payload = {
        userId,
        token,
      }

      if (notification) payload.notification = notification

      const response = await api.unreadNotification(payload)

      console.log('unreadNotification response:', response)

      if (Array.isArray(response.notifications)) {
        dispatch(setNotifications(response.notifications))
      }

      dispatch(setLoading(false))
    } catch (e) {
      dispatch(setLoading(false))
    }
  }
}
